import { Delete as DeleteIcon } from '@material-ui/icons';
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  IconButton,
} from '@material-ui/core';
import { Field } from 'redux-form';
import { TextField } from 'iqvia-shared/components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';

import { checkLength, checkRequired } from '../../../../Shared/Forms/FormValidation';
import { uniquePathNameValidator } from './validators';
import PathObjects from './PathObjects';
import PathStatus from './PathStatus';

export const styles = {
  name: {
    '& input': {
      borderColor: '#fff',
      '&:focus': {
        borderColor: '#1f6afc',
      },
    },
    '& > div': {
      margin: 0,
    },
  },
  delete: {
    paddingTop: '0px !important',
    textAlign: 'right',
  },
  details: {
    background: '#fbfbfb',
    display: 'block',
  },
  wrapper: {
    width: '434px',
  },
};

const PathComponent = ({
  classes,
  item,
  index,
  renamePathDispatch,
  removePathDispatch,
  readonlyForm,
}) => {
  const [expanded, setExpanded] = useState(false);
  const handleExpansionPanelChange = panel => (event, isExpanded) => {
    if (event.target.tagName.toLowerCase() !== 'input') {
      setExpanded(isExpanded ? panel : false);
    }
  };

  const handleNameChange = value => renamePathDispatch(index, value);

  return (
    <React.Fragment>
      <ExpansionPanel
        expanded={expanded === item.arguments.branchResult}
        onChange={handleExpansionPanelChange(item.arguments.branchResult)}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container spacing={8} className={classes.wrapper}>
            <Grid item xs={5} className={classes.name}>
              <Field
                name={item.arguments.branchResult}
                component={TextField}
                disabled={readonlyForm}
                onChange={(_, value) => handleNameChange(value)}
                validate={[checkRequired, uniquePathNameValidator, value => checkLength(value, 50)]}
              />
            </Grid>
            <Grid item xs={5}>
              {!expanded && <PathStatus item={item} />}
            </Grid>
            <Grid item xs={2} className={classes.delete}>
              <IconButton onClick={() => removePathDispatch(index)} disabled={readonlyForm}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.details}>
          <PathObjects item={item} index={index} readonlyForm={readonlyForm} />
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </React.Fragment>
  );
};

PathComponent.displayName = 'PathComponent';

export default PathComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathComponent.js